<template>
    <ValidationProvider
        slim
        :mode="mode"
        :rules="rulesLocal"
        ref="provider"
        v-bind="$attrs"
        v-on="$listeners">
        <slot v-for="(_, name) in $slots" :name="name" :slot="name"/>
        <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData">
            <slot :name="name" v-bind="slotData"/>
        </template>
    </ValidationProvider>
</template>

<script>

export default {
    name: 'AfValidationProvider',
    props: {
        disableValidation: {
            type: Boolean,
            default: false
        },
        rules: {},
        mode: {
            type: String,
            default: 'eager'
        }
    },
    computed: {
        rulesLocal() {
            return this.disableValidation === true ? '' : this.rules
        }
    },
    methods: {
        validate(e) {
            return this.$refs.provider.validate(e)
        }
    }
}

</script>
